import { DrawPrizeListResponse } from '@/modules/draw/draws/services/apiValidation/drawPrizeListApiValidation.ts'

export const drawPrizesPage1: { data: DrawPrizeListResponse } = {
  data: {
    results: [
      {
        id: 1,
        type: 'PHONE_RECHARGE',
        subtype: 'PHONE_RECHARGE_1500',
        quantity: 1,
        maxAmount: '10.00',
        appears: 1,
        isActive: true,
        drawId: 1,
        drawName: 'Sorteo Semanal'
      },
      {
        id: 2,
        type: 'PHONE_RECHARGE',
        subtype: 'PHONE_RECHARGE_1200',
        quantity: 2,
        maxAmount: '25.00',
        appears: 2,
        isActive: true,
        drawId: 1,
        drawName: 'Sorteo Semanal'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  }
}
